import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Add this import

const VendorSignupFull = () => {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    zipcode: ''
  });
  const [message, setMessage] = useState('');
  const [services, setServices] = useState([]);
  const [serviceDetails, setServiceDetails] = useState({});
  const [selectedDetails, setSelectedDetails] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch all services
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/services`)
      .then(res => res.json())
      .then(data => {
        // Only show services where is_active is true
        const activeServices = Array.isArray(data)
          ? data.filter(service => service.is_active === true || service.is_active === 1)
          : [];
        setServices(activeServices);
      });

    // Fetch all service details for each service
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/service_details/all`)
      .then(res => res.json())
      .then(data => {
        // data should be an array of details with service_id
        const detailsByService = {};
        data.forEach(detail => {
          if (!detailsByService[detail.service_id]) detailsByService[detail.service_id] = [];
          detailsByService[detail.service_id].push(detail);
        });
        setServiceDetails(detailsByService);
      });
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleDetailCheck = (serviceId, detailId) => {
    setSelectedDetails(prev => {
      const current = prev[serviceId] || [];
      if (current.includes(detailId)) {
        // Remove
        return { ...prev, [serviceId]: current.filter(id => id !== detailId) };
      } else {
        // Add
        return { ...prev, [serviceId]: [...current, detailId] };
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
  const res = await fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/vendors/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage('Sign up successful! Please check your email for verification.');
        setTimeout(() => {
          window.location.href = '/signin';
        }, 1500);
      } else {
        setMessage(data.message || 'Sign up failed.');
      }
    } catch (err) {
      setMessage('Sign up failed.');
    }
  };

  const handleNext = () => {
    localStorage.setItem('selectedDetails', JSON.stringify(selectedDetails));
    navigate('/vendorsignupnext');
  };

  // Check if at least one detail is picked
  const isAnyDetailPicked = Object.values(selectedDetails).some(arr => Array.isArray(arr) && arr.length > 0);

  return (
    <div style={styles.container}>
      <div style={styles.servicesSection}>
        <h3 style={styles.servicesTitle}>Pick the services that you want to offer(You can change it later)</h3>
        {services.map(service => (
          <div key={service.id} style={styles.serviceCard}>
            <h4 style={styles.serviceName}>{service.name}</h4>
            <p style={styles.serviceDesc}>{service.description}</p>
            <div style={styles.detailsGrid}>
              {serviceDetails[service.id] && serviceDetails[service.id].map(detail => (
                <div key={detail.id} style={styles.detailCard}>
                  <label style={{ display: 'block', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={selectedDetails[service.id]?.includes(detail.id) || false}
                      onChange={() => handleDetailCheck(service.id, detail.id)}
                      style={{ marginRight: '8px' }}
                    />
                    <span style={{ fontWeight: 'bold', color: '#4078c0', fontSize: '1.08rem' }}>
                      {detail.name}
                    </span>
                  </label>
                  <p style={{ margin: '8px 0 0 0', color: '#555', fontSize: '0.98rem' }}>
                    {detail.description}
                  </p>
                  {detail.image_url && (
                    <img
                      src={detail.image_url}
                      alt={detail.name}
                      style={{
                        width: '100%',
                        maxHeight: '120px',
                        objectFit: 'cover',
                        borderRadius: '6px',
                        marginTop: '10px',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <button
        style={styles.button}
        type="button"
        onClick={handleNext}
        disabled={!isAnyDetailPicked}
      >
        Next
      </button>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '40px auto',
    padding: '24px',
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    maxWidth: '400px',
    margin: '0 auto 32px auto',
  },
  title: {
    marginBottom: '16px',
    color: '#4078c0',
    fontSize: '1.5rem',
  },
  input: {
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '1rem',
  },
  button: {
    padding: '10px',
    borderRadius: '6px',
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1rem',
    border: 'none',
    cursor: 'pointer',
  },
  message: {
    marginTop: '16px',
    color: '#4078c0',
    fontSize: '1rem',
  },
  servicesSection: {
    marginTop: '40px',
  },
  servicesTitle: {
    color: '#4078c0',
    fontSize: '1.3rem',
    marginBottom: '24px',
    textAlign: 'center',
  },
  serviceCard: {
    background: '#f5f6fa',
    borderRadius: '8px',
    padding: '18px',
    marginBottom: '24px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
  },
  serviceName: {
    color: '#4078c0',
    fontWeight: 'bold',
    fontSize: '1.15rem',
    marginBottom: '8px',
  },
  serviceDesc: {
    color: '#555',
    marginBottom: '8px',
  },
  detailsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '18px',
    marginTop: '12px',
  },
  detailCard: {
    background: '#fff',
    borderRadius: '8px',
    padding: '14px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
    marginBottom: '0',
    minHeight: '120px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  detailsList: {
    display: 'none', // Hide old list style
  },
  detailItem: {
    fontSize: '1rem',
    marginBottom: '6px',
  },
};

export default VendorSignupFull;